import { Link } from 'react-router-dom';
import { aboutInfo } from '@/mocks/sports';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-lg bg-primary-500">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-background-50 rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-500 rounded-full translate-y-1/2 -translate-x-1/2"></div>
          </div>
          <div className="relative px-6 py-14 md:py-20 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
              加入bb体育，感受竞技魅力
            </h2>
            <p className="mt-3 text-sm md:text-base text-white/80 max-w-2xl mx-auto">
              实时比分、赛事直播、深度分析——一站式体育娱乐体验，尽在bb体育
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
              <Link
                to="/about"
                className="px-8 py-3 bg-background-50 text-primary-600 font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                了解更多
              </Link>
              <Link
                to="/category/football"
                className="px-8 py-3 bg-white/15 text-background-50 font-medium rounded-full hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer text-sm border border-white/20"
              >
                浏览赛事
              </Link>
            </div>
            <div className="flex items-center justify-center gap-8 mt-10">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-background-50">
                    {stat.value}
                  </div>
                  <div className="text-xs text-white/70 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}